import { requestService } from '../helpers/request.service';

export const mmRecordService = {
    getMMRecord,
    getHeader,
    getInvestigations,
    getOptionalInvestigations,  
    getNomInvestigations,
    getInvestigationsWithPrice,
    getNomInvestigationById,
    getDiagnostics,
    getFiles,
    getNoxes,
    getRecommanedations,
    getNoxesInvestigations,
    getAllNoxes,
    getLastRecord,
    saveMMRecord,
    getRiskyNoxes,
    downloadFisaMM
}

function getMMRecord(params) {
        return requestService.get({
            methodName: '/MMRecords/GetMMRecordById',
            queryString: params
        });
}

function getHeader(params) {
    return requestService.get({
        methodName: '/MMRecords/GetHeader',
        queryString: params
    });
}

function getInvestigations(params) {
    return requestService.get({
        methodName: '/MMRecords/GetInvestigations',
        queryString: params
    });
}


function getOptionalInvestigations(params) {
    return requestService.get({
        methodName: '/MMRecords/GetOptionalInvestigations',
        queryString: params
    });
}

function getNomInvestigations(params) {
    return requestService.get({
        methodName: '/MMRecords/GetNomInvestigations',
        queryString: params
    });
}


function getInvestigationsWithPrice(params) {
    return requestService.get({
        methodName: '/MMRecords/GetInvestigationsWithPrice',
        queryString: params
    });
}


function getNomInvestigationById(params) {
    return requestService.get({
        methodName: '/MMRecords/GetNomInvestigationById',
        queryString: params
    });
}



function getDiagnostics(params) {
    return requestService.get({
        methodName: '/MMRecords/GetDiagnostics',
        queryString: params
    });
}

function getFiles(params) {
    return requestService.get({
        methodName: '/MMRecords/GetFiles',
        queryString: params
    });
}

function getRecommanedations(params) {
    return requestService.get({
        methodName: '/MMRecords/GetRecommendations',
        queryString: params
    });
}

function getNoxes(params) {
    return requestService.get({
        methodName: '/MMRecords/GetNoxes',
        queryString: params
    });
}


function getNoxesInvestigations(params) {
    return requestService.get({
        methodName: '/MMRecords/GetNoxesInvestigations',
        queryString: params
    });
}

function getAllNoxes() {
    return requestService.get({
        methodName: '/MMRecords/GetNoxesAll',
    });
}

function getRiskyNoxes() {
    return requestService.get({
        methodName: '/MMRecords/GetRiskyNoxes',
    });
}

function getLastRecord(params) {
    return requestService.get({
        methodName: '/MMRecords/GetLastRecord',
        queryString: params
    });
}

function saveMMRecord(params) {
    return requestService.formData({
        methodName: '/MMRecords/SaveMMRecord',
        body: params
    });
}


function downloadFisaMM(params) {
    return requestService.get({
        methodName: '/MMRecords/GetReportFromManagDoc',
        queryString: params
    });
}



